import { Button, Result } from 'antd';
import React from 'react';

/** Refresh also retries a stuck JS/CSS chunk, which a local data retry cannot. */
const LoadingRecovery: React.FC = () => (
  <Result
    status="warning"
    title="页面加载超时"
    subTitle="页面文件或数据未能及时加载，请检查网络后重新加载。"
    extra={
      <Button type="primary" onClick={() => window.location.reload()}>
        重新加载
      </Button>
    }
  />
);

export default LoadingRecovery;
